import React from 'react'
import {
    Button,
    Divider,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select  ,
    useToast
} from '@chakra-ui/react'
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from 'axios'
import { Auth } from './Auth';

// member formik value
const memberValues = {
    firstName: '',
    lastName: '',
    Email: '',
    Password: '',
    Phone: '',
    Role: ''
}
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

Yup.setLocale({
    string: {
      email: 'Invalid email format',
    },
  });
const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
// member Yup Validation schema
const memberSchema = Yup.object({
    firstName: Yup.string().min(1, "First name must be at least 1 characters").required("Please enter your first name"),
    lastName: Yup.string().min(1, "Last name must be at least 1 characters").required("Please enter your last name"),
    Email: Yup.string().matches(emailRegExp, 'Email is not valid').required("Please enter your email"),
    Password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
    Phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required("Please enter your phone number"),
    Role: Yup.string().required("Please select admin role")
  });

function UserForm({onClose , renderData}) {
    // const { isOpen, onOpen, onClose } = useDisclosure()
    const toast = useToast()
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: memberValues,
      validationSchema: memberSchema,
      onSubmit: (values, action) => {

        // API CALL FOR SINGUP USER ACCESS
        let data = JSON.stringify({
          "email": `${values.Email}`,
          "phone": `${values.Phone}`,
          "firstName": `${values.firstName}`,
          "lastName": `${values.lastName}`,
          "password": `${values.Password}`
        });
        
        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/signup`,
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': Auth()
          },
          data : data
        };
        
        axios.request(config)
        .then((response) => {
        // -------- ASSINGNING ACCESS ------
        
        let data = JSON.stringify({
          "userGroupId": `${(values.Role)}`,
          "userPermissions": values.Role === 'MEMBER' ? ["DELIVERY_MANAGEMENT"] : values.Role === 'DELEVERY_BOY' ? ["DELIVERY_MANAGEMENT"] :
           values.Role === 'ADMIN' ? ['ORDER_MANAGEMENT', 'TENURE_MANAGEMENT', 'USER_MANAGEMENT', 'INVOICE_MANAGEMENT', 'PAYMENT_MANAGEMENT', 'SETTLEMENT_MANAGEMENT', 'RETURNS_MANAGEMENT',
            'CUSTOMER_MANAGEMENT', 'NOTIFICATION_MANAGEMENT', 'DISCOUNT_MANAGEMENT', 'DISPUTE_MANAGEMENT', 'SETTINGS_MANAGEMENT', 'DELIVERY_MANAGEMENT'] : null,
          "userId": `${response.data.userAccount.id}`
        });
        
        let config2 = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/assign-access`,
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': Auth()
          },
          data : data
        };
        
        axios.request(config2)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          toast({
            title: `${values.Role.split('_').join(' ')} added sucessfully`,
            duration: 3000,
            position: 'top',
            status: 'success',
            isClosable: true,
          })
          renderData()
        })
        .catch((error) => {
          console.log(error);
          toast({
            title: `Something went wrong please try again later`,
            duration: 3000,
            position: 'top',
            status: 'error',
            isClosable: true,
          })
        });
        })
        .catch((error) => {
          console.log(error);
           toast({
          title: `Something went wrong please try again later with different EMAIL Id`,
          duration: 3000,
          position: 'top',
          status: 'error',
          isClosable: true,
        })
        });
        
        onClose()
        action.resetForm()
      },


    });
  return (
    <ModalContent>
    <ModalHeader textAlign={'center'}>Add Member</ModalHeader>
    <Divider/>
    <ModalCloseButton />
    <ModalBody pb={6}>

        <FormControl mt={4} isInvalid={errors.firstName && touched.firstName}>
            <FormLabel>First Name</FormLabel>
            <Input placeholder='Enter your name' name='firstName' value={values.firstName} onChange={handleChange} onBlur={handleBlur} autoComplete="off" />
            {errors.firstName && touched.firstName ? (
            <FormErrorMessage>{errors.firstName}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.lastName && touched.lastName}>
            <FormLabel>Last Name</FormLabel>
            <Input placeholder='Enter your name' name='lastName' value={values.lastName} onChange={handleChange} onBlur={handleBlur} autoComplete="off" />
            {errors.lastName && touched.lastName ? (
            <FormErrorMessage>{errors.lastName}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.Email && touched.Email}>
            <FormLabel>Email ID</FormLabel>
            <Input type="email" placeholder='Enter your email id' name='Email' value={values.Email} onChange={handleChange} onBlur={handleBlur} autoComplete="off" />
            {errors.Email && touched.Email ? (
            <FormErrorMessage>{errors.Email}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.Password && touched.Password}>
            <FormLabel>Password</FormLabel>
            <Input type="password" placeholder='Enter Password' name='Password'  value={values.Password} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            {errors.Password && touched.Password ? (
            <FormErrorMessage>{errors.Password}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.Phone && touched.Phone}>
            <FormLabel>Phone No.</FormLabel>
            <Input placeholder='Enter your contact no.' name='Phone' value={values.Phone} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            {errors.Phone && touched.Phone ? (
            <FormErrorMessage>{errors.Phone}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.Role && touched.Role}>
            <FormLabel>Role</FormLabel>
            <Select name="Role" placeholder="Select Role" onChange={handleChange} onBlur={handleBlur} value={values.Role}> 
                <option value='ADMIN'>Admin</option>
                <option value='DELEVERY_BOY'>Delivery Boy</option>
                <option value='MEMBER'>Member</option>
            </Select>
            {errors.Role && touched.Role ? (
            <FormErrorMessage>{errors.Role}</FormErrorMessage>
            ) : null}
        </FormControl>
    </ModalBody>

    <ModalFooter>
         <Button  mr={3} onClick={onClose}>Cancel</Button>
         <Button colorScheme='blue' onClick={handleSubmit}>
             Save
         </Button>
    </ModalFooter>
</ModalContent>
  )
}

export default UserForm